export default __webpack_public_path__ + "static/media/camino3_instrucciones.5c679008.png";